import * as actions from '../actions/actionTypes';

const initialState = {
  states: [],
  cities: [],
  searchAddress: {},
};

const fetchStatesSuccess = (state, action) => ({ ...state, states: action.data });

const fetchCitiesSuccess = (state, action) => ({ ...state, cities: action.data });

const fetchAddressSuccess = (state, action) => ({ ...state, searchAddress: action.data });

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_STATES_SUCCESS: return fetchStatesSuccess(state, action);
    case actions.FETCH_CITIES_SUCCESS: return fetchCitiesSuccess(state, action);
    case actions.FETCH_ADDRESS_SUCCESS: return fetchAddressSuccess(state, action);
    default: return state;
  }
};

export default reducer;
